import { useState, useEffect } from 'react';

export function useWindowDimensions() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const updateWindowDimensions = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateWindowDimensions);
    return () => window.removeEventListener('resize', updateWindowDimensions);
  }, [window.innerWidth]);

  useEffect(() => {
    const updateWindowDimensions = () => {
      setWindowHeight(window.innerHeight);
    };
    window.addEventListener('resize', updateWindowDimensions);
    return () => window.removeEventListener('resize', updateWindowDimensions);
  }, [window.innerHeight]);

  useEffect(() => {
    function updateAfterOrientationChange() {
      function updateHeightAndWidth() {
        setWindowHeight(window.innerHeight);
        setWindowWidth(window.innerWidth);
        window.removeEventListener('resize', updateHeightAndWidth);
      }
      window.addEventListener('resize', updateHeightAndWidth);
    }
    window.addEventListener('orientationchange', updateAfterOrientationChange);
    return () => window.removeEventListener('orientationchange', updateAfterOrientationChange);
  }, []);

  return { windowHeight, windowWidth };
}
